export default {
  "content": "<path d=\"M23.064 4h-5.5V1.3a1.3 1.3 0 00-1.3-1.3h-7.4a1.3 1.3 0 00-1.3 1.3V4h-5.5a1.5 1.5 0 00-1.5 1.5v13a1.5 1.5 0 001.5 1.5h21a1.5 1.5 0 001.5-1.5v-13a1.5 1.5 0 00-1.5-1.5zm-13.5-2h6v2h-6V2zm12.93 5.371l-2 5a1 1 0 01-.93.629h-4v.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5V13h-4a1 1 0 01-.929-.629l-2-5a1 1 0 011.858-.742L6.241 11h3.323v-.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v.5h3.323l1.748-4.371a1 1 0 111.858.742z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "25",
    "height": "20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};